import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * BACKUPS notification formatter
 * Extends notification with a link to the backup run detail page
 * and additional status/message params
 */
export default class BackupsFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const payload = notification.payload
    const id = payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = []

    if (payload?.status) {
      additionalParams.push({
        key: payload.status
      })
    }

    if (payload?.message) {
      additionalParams.push({
        key: payload.message
      })
    }

    if (payload?.includeDatabase !== undefined && payload?.includeStorage !== undefined) {
      if (payload.includeDatabase && payload.includeStorage) {
        additionalParams.push({ key: 'include_database_and_storage' })
      } else if (payload.includeDatabase) {
        additionalParams.push({ key: 'include_database' })
      } else if (payload.includeStorage) {
        additionalParams.push({ key: 'include_storage' })
      }
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/backups/${id}` : undefined
    }
  }
}
